module.exports = __webpack_public_path__ + "static/media/cy.bc3ce218.jpeg";